<section class="products-feedback" id="products-feedback">

    <app-header class="offers--active products--active"></app-header>
    
    <div class="page">
        <div class="box-title">
            <div class="container">
                <h1 class="title-one">Hiciste la mejor inversión</h1>
                <p class="title-description">A partir de este momento puedes usar tu plan.</p>
            </div>
        </div>

        <div class="container container-feedback" *ngIf="isSuccess">
            <div class="grid feedback-card">
                <div class="grid-12 grid-md-6 feedback-card__image">
                    <picture class="image--success">
                        <source media="(max-width: 959px)" srcset="./assets/images/products/feedback-success-mobile.png">
                        <source media="(min-width: 960px)" srcset="./assets/images/products/feedback-success.png">
                        <img class="img-responsive" src="./assets/images/products/feedback-success-mobile.png" alt="Hombre feliz validando"> 
                    </picture>
                </div>
                <div class="grid-12 grid-md-6 feedback-card__content">
                    <h2 class="title text-mid text-primary-dark">¡Pago exitoso!</h2>
                    <p class="description">Recuerda que desde tu cuenta siempre podrás comprar los productos que necesites.</p>
                    <button class="button secondary rounded mt-medium mb-large text-small" type="button" (click)="button()">ir a mi cuenta</button>
                </div>
            </div>
        </div>

        <div class="container container-feedback" *ngIf="isPending">
            <div class="grid feedback-card">
                <div class="grid-12 grid-md-6 feedback-card__image">
                    <picture class="image--warning">
                        <source media="(max-width: 959px)" srcset="./assets/images/products/feedback-warning-mobile.png">
                        <source media="(min-width: 960px)" srcset="./assets/images/products/feedback-warning.png">
                        <img class="img-responsive" src="./assets/images/products/feedback-warning-mobile.png" alt=""> 
                    </picture>
                </div>
                <div class="grid-12 grid-md-6 feedback-card__content">
                    <h2 class="text-mid text-grayscale-gray-5">Transacción pendiente por confirmar</h2>
                    <p class="description">Te recomendamos contactar a tu entidad bancaria para solucionarlo.</p>
                    <button class="button secondary rounded mt-medium mb-large text-small" type="button" (click)="button()">Volver al inicio</button>
                </div>
            </div>
        </div>

        <div class="container container-feedback" *ngIf="isWarning">
            <div class="grid feedback-card">
                <div class="grid-12 grid-md-6 feedback-card__image">
                    <picture class="image--error">
                        <source media="(max-width: 959px)" srcset="./assets/images/products/feedback-error-mobile.png">
                        <source media="(min-width: 960px)" srcset="./assets/images/products/feedback-error.png">
                        <img class="img-responsive" src="./assets/images/products/feedback-error-mobile.png" alt="">
                    </picture>
                </div>
                <div class="grid-12 grid-md-6 feedback-card__content">
                    <h2 class="text-mid text-grayscale-gray-5">Ha ocurrido un imprevisto al realizar tu transacción</h2>
                    <p class="description">Te recomendamos contactar a tu entidad bancaria para solucionarlo o intenta realizar el pago nuevamente.</p>
                    <button class="button secondary rounded mt-medium mb-large text-small" type="button" (click)="button()">Reintentar el pago</button>
                </div>
            </div>
        </div>

    </div>
    <lib-cc-footer [ccEnvironment]="ccEnvironment"></lib-cc-footer>
</section>